/* DGA nieuwe huisstijl: het beeldmerk (een schuin aanzicht van een veer) veert.
   - bij binnenkomst veert het icoon in de header en in de footer een klein beetje
   - bij hover veert het subtiel in en weer uit
   Het headerlogo is een afbeelding met icoon en woordmerk samen; de nieuwe huisstijl toont daar via CSS het bestand
   dga-brand-logo.svg. Dit script haalt altijd dat huisstijlbestand op (niet de oude afbeelding uit het thema), zet
   het als inline SVG op dezelfde plek (maat via dga-brand-ws2-header.css, gelijk aan de afbeelding) en zet alleen
   de delen van het icoon in een eigen groep, zodat alleen de veer beweegt en het woordmerk stil blijft staan.
   Het footerlogo is alleen het icoon en beweegt in z'n geheel, zodra het in beeld komt.
   Bij 'beweging verminderen' gebeurt er niets en blijft de gewone afbeelding staan.
   Wordt geladen op alle WS2.0-templates (snippets/meta-tags.liquid). */
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce)return;
  var BRAND_LOGO='/cdn/shop/files/dga-brand-logo.svg';
  function play(el,cls){el.classList.remove(cls);void el.getBoundingClientRect();el.classList.add(cls);}
  function bind(el,hoverTarget){
    play(el,'pg-veer-in');
    el.addEventListener('animationend',function(){el.classList.remove('pg-veer-in','pg-veer-hover');});
    (hoverTarget||el).addEventListener('mouseenter',function(){if(!el.classList.contains('pg-veer-in'))play(el,'pg-veer-hover');});
  }
  function shownSrc(img){
    /* De huisstijl vervangt de afbeelding via CSS 'content:url(...)'. Is die stijl op dit moment nog niet
       toegepast, dan zou img.src het oude logo opleveren; daarom altijd terugvallen op het huisstijlbestand. */
    var c=getComputedStyle(img).content||'';var m=c.match(/url\(["']?([^"')]+)["']?\)/);
    return (m&&/dga-brand-logo/.test(m[1]))?m[1]:BRAND_LOGO;
  }
  function headerLogo(){
    var img=document.querySelector('.shopify-section-group-header-group img.header__heading-logo');
    if(!img||img.dataset.pgVeer)return;img.dataset.pgVeer='1';
    fetch(shownSrc(img),{credentials:'omit'}).then(function(r){return r.ok?r.text():Promise.reject();}).then(function(txt){
      var doc=new DOMParser().parseFromString(txt,'image/svg+xml');var svg=doc.documentElement;
      if(!svg||svg.nodeName.toLowerCase()!=='svg')return;
      svg=document.importNode(svg,true);
      svg.setAttribute('class',img.className+' pg-logo-svg');svg.setAttribute('role','img');svg.setAttribute('aria-label',img.alt||'DGA Vending');
      svg.removeAttribute('width');svg.removeAttribute('height');svg.style.overflow='visible';
      img.parentNode.replaceChild(svg,img);
      /* Het icoon staat links in het logo: de delen die daar beginnen gaan samen in een groep */
      var vb=(svg.getAttribute('viewBox')||'0 0 810 167').split(/[\s,]+/).map(Number);
      var g=document.createElementNS('http://www.w3.org/2000/svg','g');g.setAttribute('class','pg-veer');
      var parts=[].slice.call(svg.querySelectorAll('path,polygon,circle,rect,ellipse,use'));
      var icon=parts.filter(function(p){try{var b=p.getBBox();return b.width>0&&b.x+b.width<=vb[0]+vb[2]*0.24;}catch(e){return false;}});
      if(!icon.length||icon.length===parts.length)return;
      icon[0].parentNode.insertBefore(g,icon[0]);icon.forEach(function(p){g.appendChild(p);});
      bind(g,svg.closest('a')||svg);
    }).catch(function(){});
  }
  function footerLogo(){
    var f=document.querySelector('.shopify-section-group-footer-group .footer-block__brand-info img');
    if(!f||f.dataset.pgVeer)return;f.dataset.pgVeer='1';
    f.classList.add('pg-veer');
    /* In de footer pas veren als het logo in beeld komt */
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){bind(f,f.closest('a')||f);io.disconnect();}});},{threshold:.6});io.observe(f);
    }else{bind(f);}
  }
  function run(){headerLogo();footerLogo();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
